import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const styles = {
  root: {
    backgroundColor: "#FFF8E1",
    borderBottom: "1px solid #FFE082",
    padding: "10px 16px",
    textAlign: "center",
    width: "100%",
    "@media (max-width: 959px)": {
      position: "fixed",
      left: 0,
      right: 0,
      zIndex: 1200,
    },
  },
  text: {
    color: "#6D4C00",
    fontSize: "0.85rem",
  },
};

const NoticeBanner = ({ 
  message, 
  messageFr, 
  visible = true, 
  classes,
  topMobile,
  style = {}
}) => {
  const { i18n } = useTranslation();
  const currentLang = ((i18n && i18n.language) || "").toLowerCase();
  const isFr = currentLang.startsWith("fr");
  const renderedMessage = (isFr ? messageFr : message) || message || messageFr || "";

  if (!visible || !renderedMessage) return null;
  // If custom top values are provided, use inline styles only on mobile
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 960;
  const hasCustomTop = topMobile !== undefined && isMobile;
  const customStyle = hasCustomTop ? {
    top: topMobile,
  } : {};

  return (
    <div 
      className={classes.root}
      style={{ ...style, ...customStyle }}
    > 
      <Typography variant="body2" className={classes.text}>
        {renderedMessage}
      </Typography>
    </div>
  );
};

export default withStyles(styles)(NoticeBanner);
